import React from 'react';
import { fmtMoney, fmtNum, fmtDate } from '../lib/utils';
import PrintHeader, { DEFAULT_COMPANY } from './PrintHeader';

const BLUE = '#1E3A8A';

export default function CutterSummaryPrint({ cutterName, rows, totals, periodLabel, company }) {
  const c = { ...DEFAULT_COMPANY, ...(company || {}) };
  return (
    <div className="bg-white text-slate-900 font-sans p-4" style={{ minWidth: 640 }}>
      <PrintHeader company={c} />

      <div className="flex items-center justify-between my-5" style={{ color: BLUE }}>
        <div className="text-sm w-44">
          <p className="font-semibold">Statement Date</p>
          <p className="num text-[15px] mt-1" dir="ltr">{fmtDate(new Date().toISOString().slice(0, 10))}</p>
        </div>
        <div className="px-8 py-2 rounded-full border-2 text-center whitespace-nowrap" style={{ borderColor: BLUE }}>
          <span className="font-arabic text-2xl leading-none align-middle" dir="rtl" style={{ unicodeBidi: 'isolate' }}>ملخص القص</span>
          <span className="mx-3 opacity-40">·</span>
          <span className="font-heading font-bold text-base uppercase tracking-wide align-middle">Cutting Summary</span>
        </div>
        <div className="text-sm w-44 text-right">
          <p className="font-semibold">Period</p>
          <p className="num text-[15px] mt-1" dir="ltr">{periodLabel}</p>
        </div>
      </div>

      <div className="mb-5 text-[15px]" style={{ color: BLUE }}>
        <span className="font-semibold text-sm">Cutter / <span className="font-arabic" style={{ unicodeBidi: 'isolate' }}>القصاص</span>:</span>{' '}
        <span className="font-bold text-slate-900 border-b border-dotted border-slate-400 px-2 text-[18px]">{cutterName}</span>
      </div>

      <table className="w-full mb-6 border" style={{ borderColor: BLUE }}>
        <thead>
          <tr className="text-white text-left" style={{ backgroundColor: BLUE }}>
            <th className="px-3 py-2.5 text-sm font-semibold w-28">Date</th>
            <th className="px-3 py-2.5 text-sm font-semibold">Products / <span className="font-arabic">المنتجات</span></th>
            <th className="px-3 py-2.5 text-sm font-semibold text-right">Rolls Cut</th>
            <th className="px-3 py-2.5 text-sm font-semibold text-right">Length (Yards)</th>
            <th className="px-3 py-2.5 text-sm font-semibold text-right">Dozens</th>
            <th className="px-3 py-2.5 text-sm font-semibold text-right w-32">Amount</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={r.date} className={i % 2 ? 'bg-[#FDF4F6]' : ''} style={{ borderTop: '1px solid #dbe3f5' }} data-testid="print-cutter-row">
              <td className="px-3 py-2.5 text-sm num whitespace-nowrap">{fmtDate(r.date)}</td>
              <td className="px-3 py-2.5 text-[13px] font-medium">{Object.entries(r.products || {}).map(([n, q]) => `${n} (${q})`).join(', ') || '—'}</td>
              <td className="px-3 py-2.5 text-right num text-[15px]">{fmtNum(r.rolls)}</td>
              <td className="px-3 py-2.5 text-right num text-[15px]">{fmtNum(r.yards)}</td>
              <td className="px-3 py-2.5 text-right num text-[15px]">{fmtNum(r.dozens)}</td>
              <td className="px-3 py-2.5 text-right num text-[15px] font-semibold whitespace-nowrap">{fmtMoney(r.amount, c.currency)}</td>
            </tr>
          ))}
          <tr className="border-t-2 font-bold" style={{ borderColor: BLUE }}>
            <td className="px-3 py-2.5 text-[15px]" colSpan="2">Totals · <span className="font-arabic">الإجمالي</span></td>
            <td className="px-3 py-2.5 text-right num text-[15px]">{fmtNum(totals.rolls)}</td>
            <td className="px-3 py-2.5 text-right num text-[15px]">{fmtNum(totals.yards)}</td>
            <td className="px-3 py-2.5 text-right num text-[15px]">{fmtNum(totals.dozens)}</td>
            <td className="px-3 py-2.5 text-right num text-[16px] whitespace-nowrap">{fmtMoney(totals.amount, c.currency)}</td>
          </tr>
        </tbody>
      </table>
      {!rows.length && <p className="text-center text-slate-400 text-sm mb-6">No cutting in this period.</p>}

      <div className="flex justify-between items-end mt-10 text-sm" style={{ color: BLUE }}>
        <div className="text-center">
          <div className="border-t border-dotted border-slate-400 w-56 mb-1.5" />
          <p>Cutter's Signature · <span className="font-arabic text-base">توقيع القصاص</span></p>
        </div>
        <div className="text-center">
          <div className="border-t border-dotted border-slate-400 w-56 mb-1.5" />
          <p>For {c.name} · <span className="font-arabic text-base">التوقيع</span></p>
        </div>
      </div>
    </div>
  );
}
